import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Badge,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Button
} from "reactstrap"
import axios from "../../utils/axios";
import { connect } from "react-redux";
import { getProfileImageUrl } from "../../helpers/image_helpers";
import Swal from 'sweetalert2';
//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
import EditPermissionsModal from "../../components/EditPermissionsModal";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "./datatables.scss"

import { FiCircle, FiCheckCircle, FiEdit, FiTrash2, FiEye, FiMoreVertical, FiUpload, FiPlus, FiX } from 'react-icons/fi';
import { IoLogInOutline } from "react-icons/io5";
import { MdOutlineEdit } from "react-icons/md";
import { TbBrandOauth } from "react-icons/tb";

const UserManagement = (props) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  document.title = "User Management | Equity Circle - Admin Dashboard";


  const breadcrumbItems = [
    { title: "User Management", link: "#" },
    { title: "All Users", link: "#" },
  ]

  const handleDelete = async (user) => {
    try {
      // Show confirmation dialog
      const confirmDelete = await Swal.fire({
        title: 'Are you sure?',
        text: `You are about to delete ${user?.name}. This action cannot be undone.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      });

      if (confirmDelete.isConfirmed) {
        const response = await axios.delete(`/api/del-user/${user.id}`);
        fetchUsers();

        // Show success message
        Swal.fire(
          'Deleted!',
          'User has been deleted successfully.',
          'success'
        );
      }
    } catch (error) {
      // Show error message
      Swal.fire(
        'Error!',
        'Failed to delete user. Please try again.',
        'error'
      );
      console.error('Error deleting user:', error);
    }
  };
  const [showPermissionModal, setShowPermissionModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showCreateUserModal, setShowCreateUserModal] = useState(false);
  const [newUser, setNewUser] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [formErrors, setFormErrors] = useState({});

  const handlePermissionUpdate = (user) => {
    setSelectedUser(user);
    setShowPermissionModal(true);
  };

  useEffect(() => {
    props.setBreadcrumbItems('User Management', breadcrumbItems)
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const response = await axios.get('/api/users/list');
      setUsers(response.data.users);
      setShowAdmins(false);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordChangeSubmit = async () => {
    try {
      const response = await axios.post('/api/change-password-admin', {
        user_id: selectedUser.id,
        password: newPassword.password
      })
      toast.success("Password changed successfully!");
      setShowPasswordModal(false);
      setNewPassword({ password: '', confirmPassword: '' });
    } catch (error) {
      toast.error("Failed to change password. Please try again.");
      console.error('Error changing password:', error);
    }
  }

  const handleCreateUser = () => {
    setShowCreateUserModal(true);
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewUser({
      ...newUser,
      [name]: value
    });
  };

  const validateForm = () => {
    const errors = {};

    if (!newUser.name.trim()) {
      errors.name = 'Name is required';
    }

    if (!newUser.email) {
      errors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(newUser.email)) {
      errors.email = 'Email is invalid';
    }

    if (!newUser.password) {
      errors.password = 'Password is required';
    } else if (newUser.password.length < 6) {
      errors.password = 'Password must be at least 6 characters';
    }

    if (newUser.password !== newUser.confirmPassword) {
      errors.confirmPassword = 'Passwords do not match';
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleUserLogin = (user) => {
    axios.post('/api/admin-direct-login', {
      user_id: user.id
    })
      .then(response => {
        console.log(response.data);
        const token = response.data.token;
        const targetUrl = `${process.env.REACT_APP_FRONTEND_BASE_URL}/auth-callback?token=${encodeURIComponent(token)}`;
        window.open(targetUrl, '_blank');
      })
      .catch(error => {
        console.error(error);
      });

  }

  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [newPassword, setNewPassword] = useState({
    password: '',
    confirmPassword: ''
  });

  const handlePasswordChange = (user) => {
    setSelectedUser(user);
    setShowPasswordModal(true);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      // Here you would typically make an API call to create the user
      const response = await axios.post('/api/register', {
        name: newUser?.name,
        email: newUser?.email,
        password: newUser?.password,
        password_confirmation: newUser?.confirmPassword
      });

      // Show success message
      Swal.fire(
        'Success!',
        'User created successfully.',
        'success'
      );

      // Reset form and close modal
      setNewUser({
        name: '',
        email: '',
        password: '',
        confirmPassword: ''
      });
      setShowCreateUserModal(false);

      // Refresh users list
      fetchUsers();
    } catch (error) {
      Swal.fire(
        'Error!',
        'Failed to create user. Please try again.',
        'error'
      );
      console.error('Error creating user:', error);
    }
  };

  const [showAdmins, setShowAdmins] = useState(false);

  const handleshowAdmins = () => {
    if(showAdmins){
      fetchUsers();
      return;
    }else{
    axios.get('/api/get-admins')
    .then(response => {
      console.log(response.data);
        setShowAdmins(true);
        setUsers(response.data.users);
      })
      .catch(error => {
        console.error(error);
      });
    }
  }

  const handleUserDisableEnable = (user) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `You are about to ${user.is_active ? 'disable' : 'enable'} ${user.name}. This action cannot be undone.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, disable it!'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/api/user-disable-enable/${user.id}`)
          .then(response => {
            console.log(response.data);
            fetchUsers();
            Swal.fire(
              'Success!',
              `User ${user.is_active ? 'disabled' : 'enabled'} successfully.`,
              'success'
            );
          })
          .catch(error => {
            console.error(error);
            Swal.fire(
              'Error!',
              `Failed to ${user.is_active ? 'disable' : 'enable'} user. Please try again.`,
              'error'
            );
          });
      }
    })
  }

  const toggleDropdown = (userId) => {
    setOpenDropdownId(openDropdownId === userId ? null : userId);
  };

  const data = {
    columns: [
      {
        label: "Profile",
        field: "profile",
        width: 150,
        sortable: false // Disable sorting for this column
      },
      {
        label: "ID",
        field: "id",
        width: 150,
        sortable: false // Disable sorting for this column
      },
      {
        label: "UserName",
        field: "username",
        width: 270,
        sortable: false // Disable sorting for this column
      },
      {
        label: "Email",
        field: "email",
        width: 200,
        sortable: false // Disable sorting for this column
      },
      {
        label: "Action",
        field: "Action",
        width: 100,
        sortable: false // Disable sorting for this column
      },
    ],
    rows: users.map((user) => ({
      profile: (
        <div className="d-flex justify-content-start gap-2 align-items-center">
          <img src={getProfileImageUrl(user)} alt="" className="rounded-circle" style={{ width: "36px", height: "36px" }} />
          {user?.name}
        </div>
      ),
      id: user.id,
      // name: user?.name,
      username: user?.username ? user?.username : 'N/A',
      email: user?.email,
      Action: (
        <>

          <Dropdown isOpen={openDropdownId === user.id} toggle={() => toggleDropdown(user.id)} className="action-dropdown">
            <DropdownToggle tag="a" className="text-dark">
              <FiMoreVertical />
            </DropdownToggle>
            <DropdownMenu right>
              <DropdownItem >
                <FiEye className="mr-1" /> View
              </DropdownItem>
              <DropdownItem onClick={() => handleUserLogin(user)}>
                <IoLogInOutline className="mr-1" /> Login User
              </DropdownItem>
              <DropdownItem onClick={() => handlePermissionUpdate(user)}>
                <TbBrandOauth className="mr-1" /> permissions
              </DropdownItem>
              <DropdownItem onClick={() => handlePasswordChange(user)}>
                <MdOutlineEdit className="mr-1" /> Change Password
              </DropdownItem>
              <DropdownItem onClick={() => handleUserDisableEnable(user)}>
                <FiCircle className="mr-1" style={{ color: user.is_active == 1 ? "red" : "green" }} /> {user.is_active == 1 ? "Disable" : "Enable"}
              </DropdownItem>
              {/* <DropdownItem className="text-danger" onClick={() => handleDelete(user)}>
                <FiTrash2 className="mr-1" /> Delete
              </DropdownItem> */}
            </DropdownMenu>
          </Dropdown>
        </>
      )
    })),
  }

  return (
    <React.Fragment>
      <EditPermissionsModal
        show={showPermissionModal}
        onHide={() => setShowPermissionModal(false)}
        user={selectedUser}
      />

      <Row>
        <Col className="col-12">
          <Card>
            <CardBody>
              <div className="d-flex justify-content-between align-items-center">
                <CardTitle className="h4">User Management Dashboard</CardTitle>
                <div>
                <Button color="primary" onClick={() => handleshowAdmins()}> 
                   {showAdmins ? "Show Users" : "Show Admins"}
                </Button>
                &nbsp;&nbsp;&nbsp;
                <Button color="primary" onClick={() => handleCreateUser()}>
                  <FiPlus className="mr-1" /> Create User
                </Button>
                </div>
              </div>
              <p className="card-title-desc">
                Manage and view user profiles with profile images, names, usernames, and email addresses.
              </p>

              <MDBDataTable className="userTable" data={data} sortable={false} />
            </CardBody>
          </Card>
        </Col>
      </Row>


      <Modal isOpen={showCreateUserModal} toggle={() => setShowCreateUserModal(false)} backdrop={false}>
        <ModalHeader toggle={() => setShowCreateUserModal(false)}>Create New User</ModalHeader>
        <Form onSubmit={handleSubmit}>
          <ModalBody>
            <FormGroup>
              <Label for="name">Full Name</Label>
              <Input
                type="text"
                name="name"
                id="name"
                value={newUser?.name}
                onChange={handleInputChange}
                invalid={!!formErrors.name}
              />
              {formErrors.name && <div className="text-danger">{formErrors.name}</div>}
            </FormGroup>

            <FormGroup>
              <Label for="email">Email</Label>
              <Input
                type="email"
                name="email"
                id="email"
                value={newUser?.email}
                onChange={handleInputChange}
                invalid={!!formErrors.email}
              />
              {formErrors.email && <div className="text-danger">{formErrors.email}</div>}
            </FormGroup>

            <FormGroup>
              <Label for="password">Password</Label>
              <Input
                type="password"
                name="password"
                id="password"
                value={newUser?.password}
                onChange={handleInputChange}
                invalid={!!formErrors.password}
              />
              {formErrors.password && <div className="text-danger">{formErrors.password}</div>}
            </FormGroup>

            <FormGroup>
              <Label for="confirmPassword">Confirm Password</Label>
              <Input
                type="password"
                name="confirmPassword"
                id="confirmPassword"
                value={newUser?.confirmPassword}
                onChange={handleInputChange}
                invalid={!!formErrors.confirmPassword}
              />
              {formErrors.confirmPassword && <div className="text-danger">{formErrors.confirmPassword}</div>}
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => setShowCreateUserModal(false)}>
              Cancel
            </Button>
            <Button type="submit" color="primary">
              Create User
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
      {/* Password Change Modal */}
      <Modal isOpen={showPasswordModal} toggle={() => setShowPasswordModal(false)} backdrop={false}>
        <ModalHeader toggle={() => setShowPasswordModal(false)}>Change Password</ModalHeader>
        <Form onSubmit={(e) => {
          e.preventDefault();
          if (newPassword.password !== newPassword.confirmPassword) {
            toast.error("Passwords don't match!");
            return;
          }
          handlePasswordChangeSubmit();
          // Add your password change logic here
        }}>
          <ModalBody>
            <FormGroup>
              <Label>New Password</Label>
              <Input
                type="password"
                value={newPassword?.password}
                onChange={(e) => setNewPassword({ ...newPassword, password: e.target.value })}
                placeholder="Enter new password"
                required
                minLength={8}
              />
            </FormGroup>
            <FormGroup>
              <Label>Confirm New Password</Label>
              <Input
                type="password"
                value={newPassword?.confirmPassword}
                onChange={(e) => setNewPassword({ ...newPassword, confirmPassword: e.target.value })}
                placeholder="Confirm new password"
                required
                minLength={8}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={() => {
              setShowPasswordModal(false);
              setNewPassword({ password: '', confirmPassword: '' });
            }}>
              Cancel
            </Button>
            <Button color="primary" type="submit">
              Update Password
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(UserManagement);